import React from 'react';
import useTranslate from 'Hooks/useTranslate';
import { useConfig } from 'AppShell/hooks';

const S2cTermsContent: React.FunctionComponent = () => {
    const { t } = useTranslate();
    const config = useConfig();
    const dataProtectionUrl = config.links.dataProtection;

    return (
        <>
            {t(
                `I would like to regularly receive newsletters about sales and special promotions. These settings can be %srevoked%s anytime`,
                [
                    `<a
                        href="${dataProtectionUrl}#opt_out_option"
                        target="_blank"
                        class="qa-login-signup-form__privacy-revoked-link"
                        rel="noreferrer"
                    >`,
                    '</a>',
                ]
            )}
        </>
    );
};

export default S2cTermsContent;
